import { useState } from 'react'
import { Tabs } from 'antd'
import { TABS_CLASS } from '@/pages/robots/RobotPositionSetup'
import { CounterFeedbackTab } from './counter-feedback/CounterFeedbackTab'
import { RobotFeedbackTab } from './robot-feedback/RobotFeedbackTab'
import { ConversationReportTab } from './conversation-feedback/ConversationReportTab'

export function FeedbackPage() {
  const [activeTab, setActiveTab] = useState('1')

  return (
    <div className="space-y-4 pb-4">
      <div className="overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-[0_18px_60px_rgba(26,26,26,0.06)]">
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          destroyOnHidden
          className={`${TABS_CLASS}`}
          items={[
            {
              key: '1',
              label: 'Đánh giá quầy',
              children: 
                <div className="p-4">
                  <CounterFeedbackTab />,
                </div>
            },
            {
              key: '2',
              label: 'Đánh giá robot',
              children: (
                <div className="p-4">
                  <RobotFeedbackTab />
                </div>
              ),
            },
            {
              key: '3',
              label: 'Báo cáo hội thoại',
              children: (
                <div className="p-4">
                  <ConversationReportTab />
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  )
}